import React from 'react'
import './calendar.css'
import MonthViewCalendar from './MonthViewCalendar/MonthViewCalendar'
import WeekViewCalendar from './WeekViewCalendar/WeekViewCalendar'
import NewCalendarEvent from './NewCalendarEvent/NewCalendarEvent'
import Axios from 'axios'
import {baseUrl} from '../assets/Animations'

import {eachDayOfInterval, endOfMonth, format, startOfToday, parse, endOfWeek, startOfWeek} from 'date-fns'
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz'
import FamilySearchPopup from './FamilySearchPopup/FamilySearchPopup'
import CalendarEvent from './CalendarEvent/CalendarEvent'
import ChangeFollowingEventsPopup from './ChangeFollowingEventsPopup/ChangeFollowingEventsPopup'
import DeleteFollowingEventsPopup from './DeleteFollowingEventsPopup/DeleteFollowingEventsPopup'
import { createAndOrganizeAllCalendarEventsForDisplayedPeriodOfTime, deleteAllEvents, deleteThisAndFollowEvents, deleteThisEvent, editAllEvents, editThisAndFollowingEvents, editThisEvent, editSoloEvent, generateNewCalendarEvent, generateNewPendingOffer, deleteSoloEvent, editSoloEventAfterOfferChange, filterOutPendingOffersAndUpdateEvent, convertUTCStringToTimezoneString, convertStringToUTCString } from './calendarFunctions'
import NewPendingOffer from './NewPendingOffer/NewPendingOffer'
import DayViewCalendar from './DayViewCalendar/DayViewCalendar'
import UnsavedCalendarEventPopup from './UnsavedCalendarEventPopup/UnsavedCalendarEventPopup'
import SuccessfullySavedPopup from '../SuccessfullySavedPopup/SuccessfullySavedPopup'
import TeacherListForCalendar from './TeacherListForCalendar/TeacherListForCalendar'
import TopBarCalendar from './TopBarCalendar/TopBarCalendar'
import CalendarLoadingCover from './CalendarLoadingCover/CalendarLoadingCover'
import axios from 'axios'

const Calendar = ({userData, socket}) => {
  const [selectedDay, setSelectedDay] = React.useState({date: startOfToday(), events: [], availabilities: []})
  const [currentMonth, setCurrentMonth] = React.useState(format(startOfToday(), 'MMMM yyyy'))
  const [allEvents, setAllEvents] = React.useState([])
  const [view, setView] = React.useState('Month view')
  const [teachers, setTeachers] = React.useState([])
  const [teachersToDisplayObject, setTeachersToDisplayObject] = React.useState({})
  const [loadingTeachers, setLoadingTeachers] = React.useState(true)
  const [openEvent, setOpenEvent] = React.useState(false)
  const [openOffer, setOpenOffer] = React.useState(false)
  const [newOfferObject, setNewOfferObject] = React.useState(false)
  const [editEventToggle, setEditEventToggle] = React.useState(false)
  const [eventObjectToEdit, setEventObjectToEdit] = React.useState(false)
  const [editedEventObjectsOriginalDate, setEditedEventObjectsOriginalDate] = React.useState(false)
  const [schoolCalendar, setSchoolCalendar] = React.useState(false)
  const [schoolFamilies, setSchoolFamilies] = React.useState([])
  const [newEvent, setNewEvent] = React.useState(false)
  const [familySearchOpen, setFamilySearchOpen] = React.useState(false)
  const [daysOfTheDisplayedMonth, setDaysOfTheDisplayedMonth] = React.useState(eachDayOfInterval({start: startOfWeek(parse(currentMonth, 'MMMM yyyy', new Date())), end: endOfWeek(endOfMonth(parse(currentMonth, 'MMMM yyyy', new Date())))}))
  const [calendarDaysWithEvents, setCalendarDaysWithEvents] = React.useState({})
  const [changeFollowingEvents, setChangeFollowingEvents] = React.useState(false)
  const [deleteFollowingEvents, setDeleteFollowingEvents] = React.useState(false)
  const [discardUnsavedChangesPopup, setDiscardUnsavedChangesPopup] = React.useState(false)
  const [discardType, setDiscardType] = React.useState('')
  const [successfullySaved, setSuccessfullySaved] = React.useState(false)
  const [offerStatusChanged, setOfferStatusChanged] = React.useState(false)
  const [loadingCover, setLoadingCover] = React.useState(false)
  const [tempEmailData, setTempEmailData] = React.useState([])

  const myToken = localStorage.getItem('token')
  const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

  React.useEffect(() => {
    const handleSocketConnection = () => {
      if (document.visibilityState === 'visible') {
        getSchoolsCalendarEvents()
        
      }
    }

  window.addEventListener('visibilitychange', handleSocketConnection)

  return () => {window.removeEventListener('visibilitychange', handleSocketConnection)}
  }, [])

  React.useEffect(() => {
    editEventToggle ? setEditedEventObjectsOriginalDate(eventObjectToEdit.dateTime) : setEditedEventObjectsOriginalDate(false)
    editEventToggle && socket.emit('openCalendarEvent', {emitter: userData.Name, packet: eventObjectToEdit})
  }, [editEventToggle])

  React.useEffect(() => {
    setDaysOfTheDisplayedMonth(eachDayOfInterval({start: startOfWeek(parse(currentMonth, 'MMMM yyyy', new Date())), end: endOfWeek(endOfMonth(parse(currentMonth, 'MMMM yyyy', new Date())))}))
  }, [currentMonth])

  React.useEffect(() => {
    if(schoolCalendar) {
      setLoadingTeachers(true)
      setTeachersToDisplayObject({})
      Axios.get(`${baseUrl}/rawteacherdata/${schoolCalendar.schoolAbbreviation.toLowerCase()}`)
      .then((res) => {
        setLoadingTeachers(false)
        setTeachers(sortAndTurnOnAllTeachers(res.data))
      })
      .catch((err) => console.log(err))
      getSchoolsCalendarEvents()
    }
  }, [schoolCalendar])

  React.useEffect(() => {
    createAndOrganizeAllCalendarEventsForDisplayedPeriodOfTime(daysOfTheDisplayedMonth, teachers, allEvents, teachersToDisplayObject, setCalendarDaysWithEvents, schoolCalendar.timeZone)
  }, [daysOfTheDisplayedMonth, allEvents, teachersToDisplayObject, teachers, selectedDay])


  React.useEffect(() => {
    socket.on('createCalendarEvent', (data) => {
      if(data.emitter !== userData.Name) {
        setAllEvents(prev => ([...prev, data.packet]))
      }
    })
    socket.on('openCalendarEvent', (data) => {
      if(data.emitter !== userData.Name) {
        console.log('they open dawg')
        
        //DO SOMETHING HERE WHEN SOMEONE ELSE IS EDITING A CALENDAR EVENT
      }
    })
    socket.on('closeAndSaveCalendarEvent-solo-events', (data) => {
      if(data.emitter !== userData.Name) {
        data.option === 1 ? setAllEvents((prev) => ([...prev.map((e) => (e.id === data.packet.response.id ? data.packet.response : e))])) : setAllEvents((prev) => filterOutPendingOffersAndUpdateEvent(prev, data.packet.response))
      }
    })
    socket.on('closeAndSaveCalendarEvent-all-events', (data) => {
      if(data.emitter !== userData.Name) {
        setAllEvents(prev => prev.map((e) => (e.id === data.packet.id ? data.packet : e)))
      }
    })
    socket.on('closeAndSaveCalendarEvent-following-events', (data) => {
      if(data.emitter !== userData.Name) {
        if(data.option === 1) {
          setAllEvents((prev) => ([...prev, data.response[1].data]))
          setAllEvents((prev) => ([...prev.filter((e) => (e.id !== data.response[0].data.id))])) 
        } else if (data.option === 2) {
          setAllEvents((prev) => ([...prev, data.response[1].data]))
          setAllEvents((prev) => ([...prev.map((e) => (e.id === data.response[0].data.id ? data.response[0].data : e))])) 
        }
      }
    })
    socket.on('closeAndSaveCalendarEvent-this-event', (data) => {
      if(data.emitter !== userData.Name) {
        setAllEvents((prev) => ([...prev.map((e) => (e.id === data.packet[0].data.id ? data.packet[0].data : e))]))
        setAllEvents((prev) => ([...prev, data.packet[1].data]))
      }
    })
    socket.on('closeAndDeleteCalendarEvent', (data) => {
      if(data.emitter !== userData.Name) {
        setAllEvents((prev) => ([...prev.filter((e) => e.id !== data.packet.id)]))
      }
    })
    socket.on('closeAndDeleteCalendarEvent-following-events' , (data) => {
      if(data.emitter !== userData.Name) {
        data.packet.option === 1 ? setAllEvents((prev) => ([...prev.filter((e) => e.lessonId !== data.packet.response.lessonId)])) : setAllEvents((prev) => ([...prev.map((e) => (e.id === data.packet.response.id ? data.packet.response : e))]))
      }
    })
    socket.on('closeAndDeleteCalendarEvent-this-event' , (data) => {
      if(data.emitter !== userData.Name) {
        data.packet.option === 1 ? setAllEvents((prev) => ([...prev.map((e) => (e.id === data.packet.response.id ? data.packet.response : e))])) : setAllEvents((prev) => ([...prev.filter((e) => e.id !== data.packet.response.id)]))
      }
    })  

  }, [socket])

  const getSchoolsCalendarEvents = () => {
    Axios.get(`${baseUrl}/calendar/school/${schoolCalendar.schoolAbbreviation.toLowerCase()}`)
    .then((res) => {setAllEvents([...res.data.sort((a, b) => a.dateTime > b.dateTime ? 1 : -1)])})
    .catch((err) => console.log(err))
  }



  const createCalendarEvent = (localEvent) => {
    setLoadingCover(true)
    let event = {...localEvent, dateTime: convertStringToUTCString(localEvent.dateTime, schoolCalendar.timeZone)} 
    Axios.post(`${baseUrl}/calendar`, {event})
    .then((res) => {
      setOpenEvent(false)
      setOpenOffer(false)
      socket.emit('createCalendarEvent', {emitter: userData.Name, packet:res.data})
      setAllEvents([...allEvents, res.data])
      setSuccessfullySaved(true)
      setLoadingCover(false)
    })
    .catch((err) => {
        console.log(err)
        setLoadingCover(false)
    })
  }

  const editTheEvent = async (kind) => {
    setLoadingCover(true)
      if(kind === "all-events") {
        await editAllEvents(eventObjectToEdit, setAllEvents, setEditEventToggle, socket, userData.Name)
      } else if(kind === "following-events") {
        await editThisAndFollowingEvents(eventObjectToEdit, editedEventObjectsOriginalDate, setAllEvents, setEditEventToggle, socket, userData.Name)
      } else if(kind === 'this-event') {
        await editThisEvent(eventObjectToEdit, editedEventObjectsOriginalDate, setAllEvents, setEditEventToggle, socket, userData.Name)
        
      }
      setChangeFollowingEvents(false)
      setTimeout(() => {setLoadingCover(false)}, 100)
  }

  const closeAndEditSoloEvent = async () => {
    if(offerStatusChanged && !eventObjectToEdit.isPendingOffer) {
      await editSoloEventAfterOfferChange(eventObjectToEdit, setAllEvents, setEditEventToggle, socket, userData.Name)
    } else {
      await editSoloEvent(eventObjectToEdit, setAllEvents, setEditEventToggle, socket, userData.Name)
    }
  }

  const closeAndDeleteSoloEvent = async () => {
    await deleteSoloEvent(eventObjectToEdit, setAllEvents, setEditEventToggle, socket, userData.Name)
  }

  const deleteTheEvent = async (kind) => {
    if(kind === "all-events") {
      await deleteAllEvents(eventObjectToEdit, setAllEvents, setEditEventToggle, socket, userData.Name)
    } else if (kind === "following-events") {
      await deleteThisAndFollowEvents(eventObjectToEdit, editedEventObjectsOriginalDate, setAllEvents, setEditEventToggle, socket, userData.Name)
    } else if(kind === 'this-event') {
      await deleteThisEvent(eventObjectToEdit, editedEventObjectsOriginalDate, setAllEvents, setEditEventToggle, socket, userData.Name)
    }
    setDeleteFollowingEvents(false)
  }

  const sortAndTurnOnAllTeachers = (t) => {
    let primingObject = {}
    t.sort((a,b) => a.Name.localeCompare(b.Name))
    t.forEach(teacher => {primingObject[teacher.Name] = {TeacherID: teacher.TeacherID, School: teacher.School, Availability: teacher.AvailabilityDetails, WantsMoreStudents: teacher.WantsMoreStudents, displayed: true, color: teacher.CalendarColor ? teacher.CalendarColor : { name: 'Blue', bgColor: 'bg-blue-800', selectedColor: 'ring-blue-800' } }});
    setTeachersToDisplayObject(primingObject)
    return t
  }

  const unselectAllTeachers = () => {
    let primingObject = {}
    Object.keys(teachersToDisplayObject).forEach(teacher => {primingObject[teacher] = {...teachersToDisplayObject[teacher], displayed: false}});
    setTeachersToDisplayObject(primingObject)
  }

  const createNewCalendarEvent = (e) => {
    if(!e) {
      e = new Date(selectedDay.date)
      e.setHours(18)
    }
    setOpenEvent(true)
    setNewEvent(generateNewCalendarEvent(e, schoolCalendar.schoolAbbreviation.toLowerCase(), userData.Name, schoolCalendar.timeZone))
  }

  const createNewPendingOffer = (e) => {
    if(!e) {e = new Date()}
    setOpenOffer(true)
    setNewOfferObject(generateNewPendingOffer(e, schoolCalendar.schoolAbbreviation.toLowerCase(), userData.Name))
  }

  return (
    <div className='whole__calendar__page__wrapper'>
      {loadingCover && <CalendarLoadingCover />}
      <SuccessfullySavedPopup show={successfullySaved} setShow={setSuccessfullySaved} />
      <ChangeFollowingEventsPopup open={changeFollowingEvents} setOpen={setChangeFollowingEvents} editTheEvent={editTheEvent} loadingCover={loadingCover} eventObjectToEdit={eventObjectToEdit} editedEventObjectsOriginalDate={editedEventObjectsOriginalDate} />
      <DeleteFollowingEventsPopup open={deleteFollowingEvents} setOpen={setDeleteFollowingEvents} deleteTheEvent={deleteTheEvent} eventObjectToEdit={eventObjectToEdit} editedEventObjectsOriginalDate={editedEventObjectsOriginalDate} />
      <UnsavedCalendarEventPopup open={discardUnsavedChangesPopup} setOpen={setDiscardUnsavedChangesPopup} discardType={discardType} setNewEvent={setNewEvent} setOpenEvent={setOpenEvent} setEditEventToggle={setEditEventToggle} setOpenOffer={setOpenOffer} />
      <NewCalendarEvent setOpenEvent={setOpenEvent} openEvent={openEvent} newEvent={newEvent} setNewEvent={setNewEvent} teachers={teachers} setFamilySearchOpen={setFamilySearchOpen} schoolCalendar={schoolCalendar} setSchoolFamilies={setSchoolFamilies} userData={userData} createCalendarEvent={createCalendarEvent} setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup} setDiscardType={setDiscardType} />
      <NewPendingOffer setOpenOffer={setOpenOffer} openOffer={openOffer} newEvent={newOfferObject} setNewOfferObject={setNewOfferObject} teachers={teachers} setFamilySearchOpen={setFamilySearchOpen} schoolCalendar={schoolCalendar} setSchoolFamilies={setSchoolFamilies} userData={userData} createNewPendingOffer={createNewPendingOffer} createCalendarEvent={createCalendarEvent} setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup} setDiscardType={setDiscardType} />
      <CalendarEvent openEvent={editEventToggle} setOpenEvent={setEditEventToggle} event={eventObjectToEdit} setFamilySearchOpen={setFamilySearchOpen} editTheEvent={editTheEvent} setEventObjectToEdit={setEventObjectToEdit} teachers={teachers} setChangeFollowingEvents={setChangeFollowingEvents} setEditedEventObjectsOriginalDate={setEditedEventObjectsOriginalDate} setDeleteFollowingEvents={setDeleteFollowingEvents} setDiscardUnsavedChangesPopup={setDiscardUnsavedChangesPopup} setDiscardType={setDiscardType} setEditEventToggle={setEditEventToggle} closeAndEditSoloEvent={closeAndEditSoloEvent} closeAndDeleteSoloEvent={closeAndDeleteSoloEvent} setOfferStatusChanged={setOfferStatusChanged} />
      <FamilySearchPopup familySearchOpen={familySearchOpen} setFamilySearchOpen={setFamilySearchOpen} schoolFamilies={schoolFamilies} setNewEvent={setNewEvent} setNewOfferObject={setNewOfferObject} setEventObjectToEdit={setEventObjectToEdit} eventObjectToEdit={eventObjectToEdit} openEvent={openEvent} openOffer={openOffer} />
      <TeacherListForCalendar teachersToDisplayObject={teachersToDisplayObject} setTeachersToDisplayObject={setTeachersToDisplayObject} loadingTeachers={loadingTeachers} setLoadingTeachers={setLoadingTeachers} unselectAllTeachers={unselectAllTeachers} />
      <TopBarCalendar schoolCalendar={schoolCalendar} setSchoolCalendar={setSchoolCalendar} createNewPendingOffer={createNewPendingOffer} createNewCalendarEvent={createNewCalendarEvent} />
      <div className='calendar__tailwind__wrapper'>
        {view === 'Month view' && <MonthViewCalendar setView={setView} dayObject={calendarDaysWithEvents} selectedDay={selectedDay} setOpenEvent={setOpenEvent} setNewEvent={setNewEvent} schoolCalendar={schoolCalendar} setSchoolCalendar={setSchoolCalendar} userData={userData} currentMonth={currentMonth}setCurrentMonth={setCurrentMonth} setEventToEdit={setEventObjectToEdit} setEditEvent={setEditEventToggle} createNewCalendarEvent={createNewCalendarEvent} setSelectedDay={setSelectedDay} />}
        {view === 'Week view' && <WeekViewCalendar setView={setView} calendarDaysWithEvents={calendarDaysWithEvents} selectedDay={selectedDay} setOpenEvent={setOpenEvent} setNewEvent={setNewEvent} schoolCalendar={schoolCalendar} setSchoolCalendar={setSchoolCalendar} userData={userData} setCurrentMonth={setCurrentMonth} setEventToEdit={setEventObjectToEdit} setEditEvent={setEditEventToggle} createNewCalendarEvent={createNewCalendarEvent} setSelectedDay={setSelectedDay} />}
        {view === 'Day view' && <DayViewCalendar setView={setView} setSelectedDay={setSelectedDay}calendarDaysWithEvents={calendarDaysWithEvents} selectedDay={selectedDay} setOpenEvent={setOpenEvent} editEventToggle={editEventToggle} openOffer={openOffer} newOfferObject={newOfferObject} newEvent={newEvent} setNewEvent={setNewEvent} schoolCalendar={schoolCalendar} setSchoolCalendar={setSchoolCalendar} userData={userData} currentMonth={currentMonth} setCurrentMonth={setCurrentMonth} setEventToEdit={setEventObjectToEdit} setEditEvent={setEditEventToggle} createNewCalendarEvent={createNewCalendarEvent} />}
      </div>
    </div>
  )
}

export default Calendar;